export default __webpack_public_path__ + "static/media/brand-14.02f333c0.png";